import { Tooltip } from "antd";
import { useState } from "react";
import styled from "styled-components";
import { ReactComponent as Eye } from "../../../../assets/icons/eye.svg";
import { ReactComponent as Hand } from "../../../../assets/icons/hand.svg";
import { ReactComponent as Pencil01 } from "../../../../assets/icons/pencil-01.svg";
import { ReactComponent as RefreshCCW01 } from "../../../../assets/icons/refresh-ccw-01.svg";
import { ReactComponent as Trash01 } from "../../../../assets/icons/trash-01.svg";
import noImage from "../../../../assets/images/common/no-image-placeholder.png";
import ImageLoadingUrl from "../../ImageLoadingUrl";
import BtnLargeSolidInverted02 from "../../buttons/BtnLargeSolidInverted02";
import CheckboxVector from "../../checkbox/CheckboxVector";

/* #region  SCOPED CSS */
const StyledPage = styled.div`
    /* #region IMPORTED FIGMA CSS */
    #UIcard-style-03-m {
        display: flex;
        padding: 8px;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        flex: 1 0 0;
        border-radius: 4px;
        background: var(--backgrounds-lines-n-400);
        position: relative;
    }

    #Frame-340 {
        display: flex;
        align-items: flex-start;
        align-self: stretch;
        border-radius: 4px;
    }

    #Image-5 {
        height: 174px;
        flex: 1 0 0;
        border-radius: 4px;
        background: #141922;
        object-fit: cover;

        //Not in figma:
        width: 100%;
        object-fit: contain;
    }

    .Frame341 {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        width: 100%;
    }

    .Frame343 {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        border-radius: 4px;
        width: 100%;
    }

    .Frame342 {
        display: flex;
        align-items: flex-start;
        background: var(--backgrounds-lines-n-500);
        gap: 8px;
        align-self: stretch;
        width: 200px;
        height: 174px;
        flex-shrink: 0;
        padding: 20px;
    }

    #Frame-160 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;
    }

    #Frame-172 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        justify-content: space-between;
        //gap: 8px;
        align-self: stretch;
        flex-shrink: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
    }

    #Frame-164 {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
    }

    #Frame-161 {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        align-self: stretch;
    }

    #CardTitle {
        color: var(--text-icons-gray-300);

        /* Label/Small - Uppercase */
        font-family: Roboto;
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 500;
        letter-spacing: 0.125px;
        text-transform: uppercase;
        display: contents;
    }

    #Frame-162 {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 8px;
        flex: 1 0 0;
        margin-left: 3px;
    }

    .RightImageContainer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 8px;
        align-self: stretch;
        max-width: 100%;
    }

    .RightImage {
        display: flex;
        width: 40px;
        height: 40px;
        flex-shrink: 0;
        border-radius: 4px;
    }

    #BOTagID {
        align-self: stretch;
        color: var(--text-icons-gray-300);
        /* Label/Small - Uppercase */
        font-family: Roboto;
        font-size: 0.625rem;
        font-style: normal;
        font-weight: 500;
        letter-spacing: 0.125px;
        text-transform: uppercase;
    }

    #Frame-171 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;
    }

    #Frame-144 {
        display: flex;
        align-items: center;
        gap: 10px;
        align-self: stretch;
    }

    #Details {
        color: var(--text-icons-gray-300);
    }

    #Line-1 {
        width: 337px; //TODO: fix this hardcoded width in figma
        flex-grow: 1; //TODO: add this to figma
        height: 1px;
        background: #3c485a;
    }

    .Frame-204 {
        display: flex;
        align-items: flex-start;
        gap: 24px;
        align-self: stretch;
    }
    .Frame-20444 {
        align-self: stretch;
    }

    .details-row-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        flex: 1 0 0;
        overflow: hidden;
    }

    .details-item {
        display: flex;
        align-items: center;
        gap: 8px;
        align-self: stretch;
    }

    .item-left {
        flex: 1 0 0;
        color: var(--text-icons-gray-300);
    }

    .item-right {
        color: var(--text-icons-gray-300);
        text-align: right;
        flex-shrink: 1;
    }

    /* #endregion */

    /* #region CUSTOM CSS */
    .Subtitle-3 {
        /* Subtitle 3 */
        font-family: Roboto;
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .LabelXS-Uppercase {
        color: var(--text-icons-gray-300);

        /* Label/XS - Uppercase */
        font-family: Roboto;
        font-size: 0.625rem;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0.1px;
        text-transform: uppercase;
    }

    &.card-borders {
        border-radius: 4px;
        border: 1px solid var(--backgrounds-lines-n-100);
    }

    .title-logo-container {
        border-radius: 4px;
        background: var(--backgrounds-lines-n-500);

        display: flex;
        height: 174px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        width: 100%;
    }

    .title-logo {
        color: var(--text-icons-blue-500);
        text-align: center;
        font-family: Roboto;
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: -0.0375rem;
    }

    .border-suspended {
        border: 1px solid var(--text-icons-orange-500);
    }
    .border-highlighted {
        border: 1px solid var(--text-icons-green-500);
    }
    .border-edited {
        border: 1px solid rgba(255, 98, 0, 1);
    }
    .border-decline {
        border: 1px solid red;
    }

    .status-banner {
        display: flex;
        padding: 12px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        position: absolute;
        right: 0.333px;
        border-radius: 0px 0px 0px 5px;
        background: var(--Buttons-All-Platforms-btn-action-green, #080);
        color: #fff;
        font-family: Roboto;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 5px; /* 50% */
        letter-spacing: 0.125px;
        text-transform: uppercase;
        z-index: 9;
    }
    .border-orange {
        border: 1px solid var(--text-icons-orange-500);
    }

    .border-red {
        border: 1px solid var(--text-icons-red-500);
    }

    .border-blue {
        border: 1px solid var(--text-icons-blue-500);
    }

    .border-green {
        border: 1px solid var(--text-icons-green-500);
    }

    .border-purple {
        border: 1px solid var(--text-icons-purple-500);
    }

    .border-yellow {
        border: 1px solid var(--text-icons-yellow-500);
    }

    .border-teal {
        border: 1px solid rgba(0, 96, 204, 1);
    }

    .border-grey {
        border: 1px solid var(--text-icons-grey-500);
    }
    .border-dark-orange {
        border: 1px solid rgba(255, 98, 0, 1);
    }

    .Frame263-left {
        position: absolute;
        top: 15px;
        left: 15px;
    }

    .Frame263-left-status-label {
        position: absolute;
        top: 40px;
        background-color: #d37e00;
        padding-left: 10px;
        padding-right: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 15px;
        font-size: 10px;
        border-radius: 0px 2px 2px 0px;
    }
    .Frame263-left-status-label.new {
        background-color: #0060cc;
    }

    /* #endregion */
`;
/* #endregion */

/** Renders a grid card component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.className - The class name for the component.
 * @param {string} props.status - The status of the card.
 * @param {boolean} props.highlighted - Indicates if the card is highlighted.
 * @param {boolean} props.highlightColor - The highlight color of the card.
 * @param {boolean} props.highlightCustomText - The highlight custom text of the card.
 * @param {boolean} props.isProfileCard - Indicates if the card is a profile card.
 * @param {string} props.profileImage - The profile image source for the card.
 * @param {string} props.profileImageFit - The object fit style for the profile image.
 * @param {boolean} props.useTitleLogo - Indicates if the title should be used instead of the image and uses the value.
 * @param {string} props.image - The image source for the card.
 * @param {string} props.imageFit - The object fit style for the image.
 * @param {boolean} props.imageHasPadding - Indicates if the image has padding.
 * @param {boolean} props.imageOnClick - The on click event for the image.
 * @param {boolean} props.hideImage - Indicates if the image is hidden.
 * @param {boolean} props.isImageWithOverlay - Indicates if the image has a title overlay.
 * @param {string} props.imageOverlay - The title overlay for the image.
 * @param {string} props.title - The title of the card.
 * @param {string} props.posLogo - The title logo of the card.
 * @param {string} props.category - The category of the card.
 * @param {Object} props.edit - Edit button object. Contains the active boolean property
 * @param {boolean} props.edit.hidden - Indicates if the edit button is hidden.
 * @param {Function} props.edit.onClick - The on click event for the edit button. *
 * @param {Object} props.suspend - Suspend button object. Contains the active boolean property
 * @param {boolean} props.suspend.hidden - Indicates if the suspend button is hidden.
 * @param {Function} props.suspend.onClick - The on click event for the suspend button.
 * @param {Object} props.view - View button object. Contains the active boolean property
 * @param {boolean} props.view.hidden - Indicates if the view button is hidden.
 * @param {Function} props.view.onClick - The on click event for the view button.
 * @param {Object} props.delete - Delete button object. Contains the active boolean property
 * @param {boolean} props.delete.hidden - Indicates if the delete button is hidden.
 * @param {Function} props.delete.onClick - The on click event for the delete button.
 * @param {string} props.hasBorders - Indicates if the card has borders.
 * @param {string} props.botagID - The botag ID of the card.
 * @param {string} props.description - The description of the card.
 * @param {string} props.detailsType - The type of details to be displayed.
 * @param {Array} props.details - The details of the card.
 * @param {string} props.idPrefix - The ID prefix of the card.
 * @param {string} props.idPrefix2 - The ID prefix of the card.
 * @param {string} props.id - The ID of the card.
 * @param {string} props.titlePrefix - The secondary title  of the card.
 * @param {string} props.secondaryTitle - The title prefix of the card.
 * @param {string} props.secondaryTitlePrefix - The secondary title prefix of the card.
 * @param {boolean} props.isCardEnabled - Indicates if the card is enabled.
 * @param {boolean} props.isCardSuspended - Indicates if the card is suspended.
 * @param {Object} props.primaryButton - The primary button object.
 * @param {string} props.primaryButton.title - The title of the primary button.
 * @param {function} props.primaryButton.onClick - The on click event for the primary button.
 * @param {Object} props.secondaryButton - The secondary button object.
 * @param {string} props.secondaryButton.title - The title of the secondary button.
 * @param {function} props.secondaryButton.onClick - The on click event for the secondary button.
 * @param {Object} props.cardData - The card data object.
 * @param {Object} props.overLayBackgroundColor - The overLay background Color
 * @param {Object} props.overLayBorderTop - The overLay border top
 * @param {boolean} props.showSelections - Indicates if the card should show selections.
 * @param {Function} props.onCheckboxClick - The function to call when the checkbox is clicked.
 * @param {boolean} [props.isSelectionsEnabled=true] - Indicates if selections are enabled.
 *
 * @returns {JSX.Element} The rendered grid card component.
 */
export default function GridCardComponent(props) {
    const {
        className,
        status,
        highlighted,
        highlightColor,
        useTitleLogo,
        isProfileCard,
        isImageWithOverlay,
        title,
        posLogo,
        edit,
        suspend,
        view,
        delete: deleteButton,
        hasBorders = false,
        detailsType = "default",
        idPrefix = "BOTAG ID:",
        id,
        titlePrefix = "Title",
        secondaryTitlePrefix,
        secondaryTitle,
        isCardEnabled = true,
        isCardSuspended = false,
        primaryButton,
        secondaryButton,
        cardData,
        showSelections = false,
        onCheckboxClick,
        isSelectionsEnabled = true
    } = props || {};
    const [isSelectionChecked, setIsSelectionChecked] = useState(false);

    /* #region METHODS */
    const isNewCard = () => {
        return status?.toLowerCase() === "new" || status?.toLowerCase() === "draft";
    };

    const handleCheckboxClick = () => {
        if (onCheckboxClick && isSelectionsEnabled) onCheckboxClick(cardData);
        setIsSelectionChecked(!isSelectionChecked);
    };
    /* #endregion */

    return (
        <StyledPage className={`${className || ""} ${hasBorders ? "card-borders" : ""}`}>
            <div
                style={{ borderColor: highlighted && highlightColor }}
                id="UIcard-style-03-m"
                className={`${highlighted ? "border-highlighted" : isCardSuspended ? "border-suspended" : ""}`}>
                {!!useTitleLogo
                    ? defaultTitleLogoSection(props)
                    : isProfileCard
                    ? profileImageSection(props)
                    : isImageWithOverlay
                    ? imageWithTitleOverlaySection(props)
                    : defaultImageSection(props)}

                <div id="Frame-160" style={{ overflow: "hidden" }}>
                    <div className="RightImageContainer">
                        <div id="Frame-172">
                            <div id="Frame-161" style={{ height: "16px" }}>
                                <div id="CardTitle" className="flex">
                                    <label className={`flex-shrink-0 ${isCardEnabled ? "text-gray-100" : ""} text`}>
                                        {titlePrefix?.replace(":", "") || "--"}
                                    </label>
                                    :&nbsp;
                                    <Tooltip
                                        placement="top"
                                        title={title}
                                        color="var(--backgrounds-lines-n-200)"
                                        overlayClassName="custom-tool-tip">
                                        <label
                                            className={`text-one-line ${
                                                isCardEnabled ? "text-blue-500" : ""
                                            } title-head`}>
                                            {title || "--"}
                                        </label>
                                    </Tooltip>
                                </div>

                                <div id="Frame-162">
                                    <Tooltip
                                        title="Edit"
                                        trigger="hover"
                                        defaultOpen={false}
                                        color="var(--backgrounds-lines-n-200)"
                                        overlayClassName="custom-tooltip">
                                        <Pencil01
                                            onClick={edit?.onClick}
                                            width="16px"
                                            height="16px"
                                            className={`${
                                                edit?.onClick || edit?.active
                                                    ? "text-green-500 cursor-pointer"
                                                    : "text-inactive hover-not-allowed"
                                            } ${edit?.hidden ? "hidden" : ""}`}
                                        />
                                    </Tooltip>
                                    {suspend?.isReenable !== true ? (
                                        <Tooltip
                                            title="Suspend"
                                            trigger="hover"
                                            defaultOpen={false}
                                            color="var(--backgrounds-lines-n-200)"
                                            overlayClassName="custom-tooltip">
                                            <Hand
                                                onClick={suspend?.onClick}
                                                width="16px"
                                                height="16px"
                                                className={`${
                                                    suspend?.onClick || suspend?.active
                                                        ? "text-orange-500 cursor-pointer"
                                                        : "text-inactive hover-not-allowed"
                                                } ${suspend?.hidden ? "hidden" : ""}`}
                                            />
                                        </Tooltip>
                                    ) : (
                                        <RefreshCCW01
                                            onClick={suspend?.onClick}
                                            width="16px"
                                            height="16px"
                                            className={`${
                                                suspend?.onClick || suspend?.active
                                                    ? "text-blue-500 cursor-pointer"
                                                    : "text-inactive hover-not-allowed"
                                            } ${suspend?.hidden ? "hidden" : ""}`}
                                        />
                                    )}

                                    {view && (
                                        <Tooltip
                                            title="View"
                                            trigger="hover"
                                            defaultOpen={false}
                                            color="var(--backgrounds-lines-n-200)"
                                            //overlayClassName="custom-tooltip"
                                            classNames={{ root: "custom-tool" }}>
                                            <Eye
                                                onClick={view?.onClick}
                                                width="16px"
                                                height="16px"
                                                className={`${
                                                    view?.onClick || view?.active
                                                        ? "text-blue-500 cursor-pointer"
                                                        : "text-inactive hover-not-allowed"
                                                } ${view?.hidden ? "hidden" : ""}`}
                                            />
                                        </Tooltip>
                                    )}

                                    <Tooltip
                                        title="Remove"
                                        trigger="hover"
                                        defaultOpen={false}
                                        color="var(--backgrounds-lines-n-200)"
                                        overlayClassName="custom-tooltip">
                                        <Trash01
                                            onClick={deleteButton?.onClick}
                                            width="16px"
                                            height="16px"
                                            className={`${
                                                deleteButton?.onClick || deleteButton?.active
                                                    ? "text-red-500 cursor-pointer"
                                                    : "text-inactive hover-not-allowed"
                                            } ${deleteButton?.hidden ? "hidden" : ""}`}
                                        />
                                    </Tooltip>
                                </div>
                            </div>

                            {secondaryTitlePrefix && (
                                <div id="Frame-161" style={{ height: "16px" }}>
                                    <div id="CardTitle" className="flex">
                                        <label className={`flex-shrink-0 ${isCardEnabled ? "text-gray-100" : ""} text`}>
                                            {secondaryTitlePrefix?.replace(":", "") || "--"}
                                        </label>
                                        :&nbsp;
                                        <Tooltip
                                            placement="top"
                                            title={secondaryTitle}
                                            color="var(--backgrounds-lines-n-200)"
                                            overlayClassName="custom-tool-tip">
                                            <label
                                                className={`text-one-line ${
                                                    isCardEnabled ? "text-blue-500" : ""
                                                } title-head`}>
                                                {secondaryTitle || "--"}
                                            </label>
                                        </Tooltip>
                                    </div>
                                </div>
                            )}

                            <label id="BOTagID" className="flex">
                                <label
                                    className={`flex-shrink-0 text-one-line ${isCardEnabled ? "text-gray-100" : ""}`}>
                                    {idPrefix?.replace(":", "") || "BOTAG ID"}
                                </label>
                                :&nbsp;
                                <Tooltip
                                    placement="top"
                                    title={title}
                                    color="var(--backgrounds-lines-n-200)"
                                    overlayClassName="custom-tool-tip">
                                    <label className={`text-one-line ${isCardEnabled ? "text-blue-500" : ""}`}>
                                        {id || "--"}
                                    </label>
                                </Tooltip>
                            </label>
                        </div>
                        {posLogo && <img className="RightImage" src={posLogo} alt="POS logo" />}
                    </div>
                    <div id="Frame-171">
                        <div id="Frame-144">
                            <label className={`LabelXS-Uppercase  ${isCardEnabled ? "text-gray-100" : ""}`}>
                                Details
                            </label>
                            <div id="Line-1"></div>
                        </div>

                        {(!detailsType || detailsType?.toLowerCase() === "default") && defaultDetailsSectionV2(props)}

                        {detailsType?.toLowerCase() === "account-details" && defaultDetailsSectionV2(props)}
                    </div>

                    <div id="Frame-164">
                        {primaryButton && (
                            <BtnLargeSolidInverted02
                                disabled={primaryButton?.onClick === undefined}
                                text={primaryButton?.title}
                                onClick={primaryButton?.onClick ? () => primaryButton?.onClick(cardData) : undefined}
                                style={{ flexGrow: "1" }}
                            />
                        )}
                        {secondaryButton && (
                            <BtnLargeSolidInverted02
                                disabled={secondaryButton?.onClick === undefined}
                                text={secondaryButton?.title}
                                onClick={
                                    secondaryButton?.onClick ? () => secondaryButton?.onClick(cardData) : undefined
                                }
                                style={{ flexGrow: "1" }}
                            />
                        )}
                    </div>

                    <div className={`Frame263-left ${showSelections ? "" : "d-none"}`}>
                        <CheckboxVector
                            disabled={!isSelectionsEnabled}
                            isChecked={isSelectionChecked}
                            onCheckboxClick={handleCheckboxClick}
                        />
                    </div>
                    {(status?.toLowerCase() === "suspended" || isNewCard()) && (
                        <div
                            className={`Frame263-left-status-label ${
                                status?.toLowerCase() !== "suspended" && isNewCard() ? "new" : ""
                            }`}>
                            {status?.toLowerCase() !== "suspended" && isNewCard() ? "New" : status}
                        </div>
                    )}
                </div>
            </div>
        </StyledPage>
    );
}

/* #region OTHER COMPONENTS */

const defaultImageSection = props => {
    const {
        details,
        image,
        image2,
        imageOnClick,
        image2OnClick,
        imageFit,
        imageHasPadding,
        hideImage,
        highlighted,
        highlightCustomText,
        highlightColor,
        imageBorderRadius
    } = props || {};

    const statuses = details?.find(detail => detail?.key === "Status:")?.value?.props?.children;
    return (
        <div
            id="Frame-340"
            style={{ overflow: "hidden", position: "relative" }}
            className={`${hideImage ? "hidden" : ""} ${imageOnClick ? "cursor-pointer" : ""}`}>
            {highlighted && (
                <div className="status-banner" style={{ background: highlighted && highlightColor }}>
                    {highlightCustomText || statuses.toUpperCase()}
                </div>
            )}

            <ImageLoadingUrl
                id="Image-5"
                src={image}
                alt="Card"
                onClick={imageOnClick}
                style={{
                    minWidth: "0px",
                    objectFit: imageFit ? imageFit : image ? "contain" : "Cover",
                    padding: imageHasPadding ? "30px" : "0px",
                    borderRadius: imageBorderRadius
                }}
            />

            <ImageLoadingUrl
                id="Image-5"
                src={image2}
                alt=""
                onClick={image2OnClick}
                style={{
                    minWidth: "0px",
                    objectFit: "Cover",
                    display: !image2 && "none",
                    borderRadius: imageBorderRadius
                }}
            />
        </div>
    );
};

const imageWithTitleOverlaySection = props => {
    const {
        hideImage,
        image,
        imageOnClick,
        imageFit,
        imageHasPadding,
        highlighted,
        highlightCustomText,
        highlightColor,
        overLayBackgroundColor,
        overLayBorderTop,
        imageOverlay
    } = props || {};

    return (
        <div
            id="Frame-340"
            style={{ overflow: "hidden", position: "relative" }}
            className={`${hideImage ? "hidden" : ""} ${imageOnClick ? "cursor-pointer" : ""}`}>
            {highlightCustomText && highlighted && (
                <div className="status-banner" style={{ background: highlighted && highlightColor }}>
                    {highlightCustomText}
                </div>
            )}
            <ImageLoadingUrl
                id="Image-5"
                src={image}
                alt="Card"
                onClick={imageOnClick}
                style={{
                    minWidth: "0px",
                    objectFit: imageFit ? imageFit : image ? "contain" : "Cover",
                    padding: imageHasPadding ? "30px" : "0px"
                }}
            />
            <div
                style={{
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    background: overLayBackgroundColor || "rgba(20, 25, 34, 0.80)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderTop: overLayBorderTop || ""
                }}>
                <ImageLoadingUrl
                    src={imageOverlay}
                    hideOnError={true}
                    hideOnNoImage={true}
                    alt="POS logo"
                    style={{
                        width: "100%",
                        height: "70px",
                        objectFit: "contain",
                        padding: "8px 32px"
                    }}
                />
            </div>
        </div>
    );
};

const defaultTitleLogoSection = props => {
    const { hideImage, useTitleLogo, imageOnClick, isCardEnabled } = props || {};

    return (
        <div
            id="Frame-340"
            style={{ overflow: "hidden" }}
            className={`${hideImage ? "hidden" : ""} ${imageOnClick ? "cursor-pointer" : ""}`}>
            <div className="title-logo-container" onClick={imageOnClick}>
                <label
                    className={`title-logo ${
                        useTitleLogo === "--" || useTitleLogo === "-" || !isCardEnabled ? "text-gray-300" : ""
                    }`}>
                    {useTitleLogo}
                </label>
            </div>
        </div>
    );
};

const profileImageSection = props => {
    const { hideImage, image, profileImage, imageOnClick, imageFit, imageHasPadding } = props || {};

    return (
        <div
            id="Frame-340"
            style={{ overflow: "hidden" }}
            className={`${hideImage ? "hidden" : ""} ${imageOnClick ? "cursor-pointer" : ""}`}>
            <div className="Frame341">
                <div className="Frame343">
                    <img
                        id="Image-5"
                        src={image}
                        alt="Card"
                        onClick={imageOnClick}
                        style={{
                            minWidth: "0px",
                            maxWidth: "100%",
                            objectFit: imageFit ? imageFit : image ? "contain" : "Cover",
                            padding: imageHasPadding ? "30px" : "0px"
                        }}
                    />
                </div>
                <img
                    className="Frame342"
                    src={profileImage || noImage}
                    alt="Profile"
                    style={{
                        borderRadius: "4px",
                        minWidth: "0px",
                        objectFit: profileImage ? "contain" : "cover"
                        // padding: imageHasPadding ? "30px" : "0px"
                    }}
                />
            </div>
        </div>
    );
};

const defaultDetailsSectionV2 = props => {
    const { details, noOfRows, isCardEnabled } = props || {};

    const keyColor = isCardEnabled ? "text-gray-100" : "text-inactive";
    const valueColor = isCardEnabled ? "text-blue-500" : "text-inactive";

    return (
        <div className="Frame-204">
            {Array.from({ length: Math.ceil(details?.length / (noOfRows ? noOfRows : 4)) }).map((_, index) => (
                <div key={index} className={"details-row-container"}>
                    {details
                        ?.slice(index * (noOfRows ? noOfRows : 4), (index + 1) * (noOfRows ? noOfRows : 4))
                        .map((detail, i) => (
                            <div key={i} className="details-item">
                                <label
                                    style={{ flex: "1 0 0" }}
                                    className={`item-left Subtitle-3 text-no-wrap ${keyColor}`}>
                                    {detail?.key}
                                </label>

                                <Tooltip
                                    placement="top"
                                    title={detail?.value}
                                    color="var(--backgrounds-lines-n-200)"
                                    overlayClassName="custom-tool-tip">
                                    <label
                                        style={{ textAlign: "right" }}
                                        className={`item-right Subtitle-3 text-one-line ${valueColor}`}>
                                        {detail?.value ?? "--"}
                                    </label>
                                </Tooltip>
                            </div>
                        ))}
                </div>
            ))}
        </div>
    );
};
/* #endregion */
